import { Form, Select } from 'antd';
import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import { tipoVolume } from './service';
import { Props } from './props';
import { TextLabel } from 'components/TextLabel';

const TipoVolume: React.FC<Props> = ({ setTipoVolume }) => {
  const { Option } = Select;
  const [opcoes, setOpcoes] = React.useState<[]>();

  useEffect(() => {
    try {
      tipoVolume.getVolumes().then((res: any) => {
        setOpcoes(res?.data.volumes);
      });
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Não foi possível carregar os tipos de volumes, por favor tente novamente!',
        showConfirmButton: true,
      });
    }
  }, []);

  const handleChange = (value: any) => {
    setTipoVolume(value);
  };

  return (
    <Form.Item
      name="tipoVolume"
      label={<TextLabel>Tipo de volume</TextLabel>}
      rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
    >
      <Select onChange={handleChange}>
        {opcoes?.map((item: any) => (
          <Option key={item.cod} value={item.cod}>
            {item.descricao}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default TipoVolume;
